// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconUserUserOperator_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8862 7.16174C11.6702 6.37656 12.7808 6.1176 13.7801 6.38488L11.9453 8.2224 12.6514 9.63662 14.0635 10.3437 15.8983 8.5062C16.1652 9.50705 15.9066 10.6192 15.1226 11.4044 13.9528 12.576 12.0561 12.576 10.8862 11.4044 9.71635 10.2328 9.71635 8.33332 10.8862 7.16174ZM10.1821 12.1097C9.8758 11.803 9.62965 11.4588 9.44365 11.0919L6.29759 15.2928 7.00366 15.9999 11.1984 12.8493C10.832 12.663 10.4884 12.4165 10.1821 12.1097ZM9.98531 5C9.98531 7.20914 8.19708 9 5.99119 9 3.78529 9 1.99706 7.20914 1.99706 5 1.99706 2.79086 3.78529 1 5.99119 1 8.19708 1 9.98531 2.79086 9.98531 5ZM7.98825 5C7.98825 6.10457 7.09413 7 5.99119 7 4.88824 7 3.99412 6.10457 3.99412 5 3.99412 3.89543 4.88824 3 5.99119 3 7.09413 3 7.98825 3.89543 7.98825 5Z" class="svg-bg"/>
  <path d="M8.63211 10.6129C7.83542 10.2204 6.93901 10 5.99119 10C2.68278 10 0.000702383 12.6856 0 15.9987H1.99706C1.99776 13.7902 3.78572 12 5.99119 12C6.48757 12 6.9628 12.0907 7.40126 12.2564L8.63211 10.6129Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18 6C18 9.31371 15.3137 12 12 12C8.68629 12 6 9.31371 6 6C6 2.68629 8.68629 0 12 0C15.3137 0 18 2.68629 18 6ZM16 6C16 8.20914 14.2091 10 12 10C9.79086 10 8 8.20914 8 6C8 3.79086 9.79086 2 12 2C14.2091 2 16 3.79086 16 6Z" class="svg-bg"/>
  <path d="M12 16C12.6925 16 13.3644 16.088 14.0053 16.2534 14.0018 16.1694 14 16.0849 14 16 14 15.3934 14.09 14.8078 14.2574 14.2559 13.532 14.0885 12.7763 14 12 14 6.47715 14 2 18.4772 2 24H4C4 19.5817 7.58172 16 12 16ZM22.259 17.9895C20.8922 19.3564 18.6761 19.3564 17.3093 17.9895 15.9424 16.6227 15.9424 14.4066 17.3093 13.0398 18.2965 12.0525 19.7269 11.7783 20.9602 12.2173L18.7235 14.454 19.4306 15.8682 20.8448 16.5753 23.0815 14.3386C23.5204 15.5719 23.2463 17.0023 22.259 17.9895ZM16.6027 18.6961C16.2563 18.3497 15.9781 17.9609 15.7683 17.5464L11.2988 23.2928 12.0059 24 17.7524 19.5305C17.3379 19.3206 16.9491 19.0425 16.6027 18.6961Z" class="svg-bg"/>
</svg>
`;
/**
 * IconUserUserOperator is a generated icon component.
 */
let IconUserUserOperator = IconUserUserOperator_1 = class IconUserUserOperator extends IconBaseElement {
    render() {
        return html `${IconUserUserOperator_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconUserUserOperator.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconUserUserOperator = IconUserUserOperator_1 = __decorate([
    customElement('zui-icon-user-user-operator')
], IconUserUserOperator);
export { IconUserUserOperator };
